// Module
var code = "<div class=\"view-apt p-4\" ng-if=\"apt\"> <breadcrumbs crumbs=\"apt.breadcrumbs\"></breadcrumbs> <h1 class=\"title\" inner-title=\"apt.headline\"></h1> <div id=\"focus\" client-emit-trk=\"view-apt\"> <div view-apt apt=\"apt\"/> </div> </div> ";
// Exports
var _module_exports =code;;
var path = '/codebuild/output/src1102606215/src/frontend/js/controllers/public/viewApt.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;